// This component has been completely replaced by alertSidePanel.tsx
// Rendering an empty fragment to avoid duplicate UI components
export function AlertsSideModal() {
  return null;
}